import { TileType } from './index';

export enum ImagePosition {
  Fill = 'Fill',
  Centered = 'Centered'
}

export type ComposerType = {
  rootComposerGroupId: number;
  rootComposerGroup: RootComposerGroup;
  tiles: ComposerGroupItem[];
};

export type RootComposerGroup = {
  id: number;
  displayName: string;
  groupUrlName?: string;
  imageUrl: string;
  name: string;
};

export type ComposerGroupItem = {
  id: number;
  referenceId: number;
  displayName: string;
  imageUrl: string;
  type: TileType;
  priceRange?: PriceRange;
  composerGroupId: number;
  taxPercentage?: number;
  tax?: number;
  hasInfo?: boolean;
  redirectUrl?: string;
  groupUrlName?: string;
  imagePosition?: ImagePosition;
  isCustomizable?: boolean;
  isOutOfStock?: boolean;
};

export type PriceRange = {
  from: number;
  to?: number;
};
